export default class transition {
    constructor(manager,top) {

        //manager
        this.manager = manager;
        this.topManager = top;

    }
    init(){
        for(let i in this.topManager.$copyList) {
            if (this.topManager.$copyList[i].nodeType != 1) continue;
            TweenMax.set(this.topManager.$copyList[i],{
                opacity:0
            });
        }
        for(let i in this.topManager.$copyList[1].querySelectorAll('span')) {
            if (this.topManager.$copyList[1].querySelectorAll('span')[i].nodeType != 1) continue;
            TweenMax.set(this.topManager.$copyList[1].querySelectorAll('span')[i], {
                opacity:0,
                rotationX:-(-25+(i*5)),
                rotationY:-(-65+(i*5)),
                rotationZ:-(15+(i*5)),
                skewX: this.topManager.randomArray.y[i],
                x:this.topManager.randomArray.x[i],
                y:this.topManager.randomArray.y[i]
            });
        }
    }
    out(){
    }
    in(){

        TweenMax.set(this.topManager.$copyList[1],{
            opacity:1
        });
        for(let i in this.topManager.$copyList[1].querySelectorAll('span')) {
            if (this.topManager.$copyList[1].querySelectorAll('span')[i].nodeType != 1) continue;
            TweenMax.to(this.topManager.$copyList[1].querySelectorAll('span')[i],1.8,{
                delay: 2.1,
                opacity: 1,
                rotationX: 0,
                rotationY: 0,
                rotationZ: 0,
                skewX: 0,
                x: 0,
                y: 0,
                ease:this.manager.ease,
            });
        }
        TweenMax.fromTo([this.topManager.$copyList[0],this.topManager.$copyList[2]],1.4,{
            opacity:0,
        },{
            delay:3.68,
            opacity:1,
            ease:this.manager.ease
        });

    }
    fadeInPhoto() {

        TweenMax.to(this.topManager.$slideList[0],.9,{
            opacity: 1,
            display: 'block',
            ease:this.manager.ease,
        });

    }
    splash(){

    }
}